'use client';

import Image from 'next/image';
import { useConfig } from '@/app/contexts/ConfigContext';
import { FITNESS_WORDING_EN } from '@/wording/fitness/FITNESS_WORDING_EN';
import { TagProps } from '@/types';
import { URL_S3 } from '@/helpers/constants';

export default function Hero({ tag }: TagProps) {
  const { wording, config } = useConfig();
  let srcImg = '';
  let srcImgMobile = '';
  let heroText = '';

  if (tag === FITNESS_WORDING_EN.text_media_2) {
    srcImg = `${URL_S3}/${config.serviceType}/images/media2-hero.webp`;
    srcImgMobile = `${URL_S3}/${config.serviceType}/images/media2-hero-mobile.webp`;
    heroText = wording!.page_media_2_content_hero_text as string;
  } else {
    // The hero images and text for the media_1 version are used as default names in both Drive and S3.
    srcImg = `${URL_S3}/${config.serviceType}/images/media1-hero.webp`;
    srcImgMobile = `${URL_S3}/${config.serviceType}/images/media1-hero-mobile.webp`;
    heroText = wording!.page_media_1_content_hero_text; // It's the default value use for non fitness service
  }

  return (
    <div className='relative sm:max-w-[1710px] max-w-[390px] mx-auto'>
      <Image
        className='hidden sm:block relative'
        height={496}
        width={1715}
        src={srcImg}
        alt='hero'
        priority
      />
      <Image
        height={173}
        width={390}
        className='block sm:hidden relative'
        src={srcImgMobile}
        alt='hero'
        priority
      />
      <div className='absolute left-0 top-0 flex items-center justify-center h-full w-full'>
        <span
          className='text-white sm:text-[80px] text-[32px] font-extrabold sm:leading-[88px] leading-9 text-center'
          style={{ color: config.theme.textColorLight }}
        >
          {heroText}
        </span>
      </div>
    </div>
  );
}
